import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInAnonymously } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Export auth instance and a helper to ensure anonymous sign-in.
export const auth = getAuth(app);

export async function ensureAnonymousSignIn() {
  try {
    if (auth.currentUser) return auth.currentUser;
    const cred = await signInAnonymously(auth);
    return cred.user;
  } catch (err) {
    // propagate error to caller after logging
    console.error("ensureAnonymousSignIn failed:", err);
    throw err;
  }
}

// Initialize App Check if a site key is provided. This helps ensure
// the Cloud Function only accepts requests from your genuine web app.
let appCheck;
try {
  // Note: .env uses REACT_APP_RECAPTCHA_SITE_KEY
  const appCheckKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
  if (appCheckKey) {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckKey),
      isTokenAutoRefreshEnabled: true,
    });
    console.log("App Check initialized");
  }
} catch (err) {
  // non-fatal — app will fall back to secret-based server validation
  console.warn("App Check initialization failed:", err);
}

export { appCheck };
